export default [
  { key: 'AC', label: 'AC' },
  { key: 'AL', label: 'AL' },
  { key: 'AP', label: 'AP' },
  { key: 'AM', label: 'AM' },
  { key: 'BA', label: 'BA' },
  { key: 'CE', label: 'CE' },
  { key: 'DF', label: 'DF' },
  { key: 'ES', label: 'ES' },
  { key: 'GO', label: 'GO' },
  { key: 'MA', label: 'MA' },
  { key: 'MT', label: 'MT' },
  { key: 'MS', label: 'MS' },
  { key: 'MG', label: 'MG' },
  { key: 'PA', label: 'PA' },
  { key: 'PB', label: 'PB' },
  { key: 'PR', label: 'PR' },
  { key: 'PE', label: 'PE' },
  { key: 'PI', label: 'PI' },
  { key: 'RJ', label: 'RJ' },
  { key: 'RN', label: 'RN' },
  { key: 'RS', label: 'RS' },
  { key: 'RO', label: 'RO' },
  { key: 'RR', label: 'RR' },
  { key: 'SC', label: 'SC' },
  { key: 'SP', label: 'SP' },
  { key: 'SE', label: 'SE' },
  { key: 'TO', label: 'TO' },
];
